/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  description: z.string().nullish(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  loopId: z.int().nullish(),
  membershipCount: z.int().nullish(),
  name: z.string(),
  oauthCredentialsId: z.int().nullish(),
  organizationId: z.string(),
  sourceId: z.string().nullish(),
  sourceOrgId: z.string().nullish(),
  sourceType: z.enum(['JIRA_TEAM', 'TEMPO_TEAM', 'ADO_TEAM']).nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
